(self.webpackChunkuklash = self.webpackChunkuklash || []).push([ [ 821 ], {
  821: function() {
    class ScrollToTop extends HTMLElement {
      constructor() {
        super(), this.button = this.querySelector('[js-scroll-to-top="button"]');
      }
      connectedCallback() {
        window.addEventListener("scroll", this.toggleButtonVisibility.bind(this)), this.button.addEventListener("click", this.scrollToTop);
      }
      disconnectedCallback() {
        window.removeEventListener("scroll", this.toggleButtonVisibility.bind(this)), this.button.removeEventListener("click", this.scrollToTop);
      }
      toggleButtonVisibility() {
        document.body.scrollTop > 2 * window.innerHeight || document.documentElement.scrollTop > 2 * window.innerHeight ? this.button.classList.remove("opacity-0", "pointer-events-none") : this.button.classList.add("opacity-0", "pointer-events-none");
      }
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    }
    customElements.get("scroll-to-top") || customElements.define("scroll-to-top", ScrollToTop);
  }
} ]);